import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

export default function ErrorModalWrapper({
  children,
  isModalOpen,
  toggleModal,
  errorMessage = '',
  size = null,
  onButtonClick = null,
}) {
  const modalContentStyle = {
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '14px',
  };

  const modalBodyStyle = {
    overflowY: 'auto',
    flex: 1,
    padding: '0',
  };

  return (
    <Modal isOpen={isModalOpen} toggle={toggleModal} centered size={size}>
      <ModalHeader
        className={`p-3 ${children ? 'border-bottom' : ''}`}
        toggle={onButtonClick}
      >
        <span className="fs-5">{errorMessage}</span>
      </ModalHeader>
      {children && (
        <div style={modalContentStyle}>
          <ModalBody style={modalBodyStyle}>{children}</ModalBody>
        </div>
      )}
    </Modal>
  );
}
